import { defineMessages } from '../define';

export const calendar = defineMessages(
  {
    'calendar.title': 'Dagatal',
    'calendar.next_up': 'Næst á dagskrá',
    'calendar.nothing_upcoming': 'Ekkert á dagskrá',
    'calendar.nothing_upcoming_hint': 'Engir viðburðir eru á dagskrá næstu vikurnar.',
    'calendar.agenda_title': 'Næstu 30 dagar',
    'calendar.agenda_empty': 'Ekkert á dagskrá næstu 30 daga.',
    'calendar.day_empty': 'Ekkert á dagskrá þennan dag.',
    'calendar.show_agenda': 'Sýna næstu 30 daga',
    'calendar.today': 'Í dag',
    'calendar.prev_month': 'Fyrri mánuður',
    'calendar.next_month': 'Næsti mánuður',
    'calendar.day_events': { one: '{count} viðburður', other: '{count} viðburðir' },
    'calendar.load_error': 'Ekki tókst að sækja dagatalið.',
    'calendar.saved_offline': 'Vistað – sent þegar netið kemst á',
    'calendar.pending_send': 'Bíður sendingar',

    'calendar.rejected.rsvp': 'Ekki vistað: svarið sem þú gafst án nettengingar var ekki tekið gilt.',
    'calendar.rejected.checkin': 'Ekki vistað: mætingarskráningin sem þú gerðir án nettengingar var ekki tekin gild.',
    'calendar.rejected.comment': 'Ekki vistað: athugasemdin sem þú skrifaðir án nettengingar var ekki send.',
    'calendar.rejected.roster': 'Ekki vistað: breyting á mætingarlista sem gerð var án nettengingar var ekki tekin gild.',

    'calendar.err.started': 'Viðburðurinn er hafinn og ekki er lengur hægt að breyta svarinu.',
    'calendar.err.cancelled': 'Viðburðurinn hefur verið felldur niður.',
    'calendar.err.series_ended':
      'Ekki er hægt að setja þessa æfingu aftur á dagskrá því hún tilheyrir ekki lengur æfingaröðinni (röðinni var breytt eða henni lokið).',
    'calendar.err.outside_window': 'Mætingarskráning er aðeins opin frá því skömmu fyrir upphaf viðburðarins og þar til honum lýkur.',
    'calendar.err.bad_time_range': 'Viðburðurinn þarf að enda eftir að hann hefst og má ekki standa lengur en í 14 daga.',
    'calendar.err.setlist_not_found': 'Lagalistinn fannst ekki. Veldu annan lista.',
    'calendar.err.program_song_not_found': 'Lag á listanum fannst ekki lengur (því hefur verið eytt). Fjarlægðu það og vistaðu aftur.',
    'calendar.err.program_collection_not_found': 'Mappa eða lagalisti á listanum fannst ekki lengur. Fjarlægðu hann og vistaðu aftur.',
    'calendar.err.reply_to_invalid': 'Athugasemdin sem þú svaraðir er ekki lengur til.',
    'calendar.err.deleted': 'Þessu hefur verið eytt.',

    'calendar.kind.practice': 'Æfing',
    'calendar.kind.sectional': 'Raddæfing',
    'calendar.kind.concert': 'Tónleikar',
    'calendar.kind.other': 'Annað',

    'calendar.wd.1': 'mán',
    'calendar.wd.2': 'þri',
    'calendar.wd.3': 'mið',
    'calendar.wd.4': 'fim',
    'calendar.wd.5': 'fös',
    'calendar.wd.6': 'lau',
    'calendar.wd.7': 'sun',
    'calendar.wd_on.1': 'mánudögum',
    'calendar.wd_on.2': 'þriðjudögum',
    'calendar.wd_on.3': 'miðvikudögum',
    'calendar.wd_on.4': 'fimmtudögum',
    'calendar.wd_on.5': 'föstudögum',
    'calendar.wd_on.6': 'laugardögum',
    'calendar.wd_on.7': 'sunnudögum',

    'calendar.rsvp.question': 'Kemur þú?',
    'calendar.rsvp.yes': 'Kem',
    'calendar.rsvp.no': 'Kem ekki',
    'calendar.rsvp.maybe': 'Óvíst',
    'calendar.rsvp.none': 'Ósvarað',
    'calendar.rsvp.unanswered_hint': 'Láttu vita hvort þú kemur.',
    'calendar.rsvp.closed': 'Ekki er hægt að breyta svari eftir að viðburðurinn hefst.',
    'calendar.rsvp.not_invited': 'Þessi viðburður er ekki ætlaður þinni rödd.',
    'calendar.note.label': 'Skýring',
    'calendar.note.add': 'Bæta við skýringu',
    'calendar.note.placeholder': 'T.d. „kem 20 mín. of seint“',
    'calendar.note.need_rsvp': 'Veldu fyrst Kem, Kem ekki eða Óvíst.',
    'calendar.note.save': 'Vista skýringu',
    'calendar.note.counter': '{n} / {max}',

    'calendar.checkin.button': 'Skrá mætingu',
    'calendar.checkin.done': 'Mætt/ur kl. {time}',
    'calendar.checkin.opens_at': 'Mætingarskráning opnast kl. {time}',
    'calendar.checkin.saved': 'Mæting skráð',

    'calendar.event.title': 'Viðburður',
    'calendar.event.cancelled': 'Fellur niður',
    'calendar.event.cancelled_banner': 'Þessi viðburður fellur niður',
    'calendar.event.reason': 'Ástæða: {reason}',
    'calendar.event.open_map': 'Opna staðsetningu í korti',
    'calendar.event.audience': 'Fyrir',
    'calendar.event.details': 'Nánar',
    'calendar.event.not_found': 'Viðburðurinn fannst ekki eða þú hefur ekki aðgang að honum.',
    'calendar.event.recurring': 'Hluti af æfingaröð',
    'calendar.event.your_reply': 'Þitt svar',
    'calendar.event.comments': { one: '{count} athugasemd', other: '{count} athugasemdir' },
    'calendar.event.unread': { one: '{count} ný', other: '{count} nýjar' },
    'calendar.event.ongoing': 'Stendur yfir',
    'calendar.event.ended': 'Lokið',
    'calendar.event.description': 'Nánar um viðburðinn',

    'calendar.headcount.title': 'Hverjir koma',
    'calendar.headcount.coming': { one: '{count} kemur', other: '{count} koma' },
    'calendar.headcount.coming_word': { one: 'kemur', other: 'koma' },
    'calendar.headcount.detail': 'Nei {no} · Óvíst {maybe} · Ósvarað {none}',
    'calendar.headcount.low': { one: 'Aðeins {count} kemur í {section}', other: 'Aðeins {count} koma í {section}' },
    'calendar.headcount.nobody': 'Enginn kemur í {section}',
    'calendar.headcount.total': 'Samtals',
    'calendar.headcount.unanswered': { one: '{count} hefur ekki svarað', other: '{count} hafa ekki svarað' },

    'calendar.board.title': 'Spjall',
    'calendar.board.empty': 'Engar athugasemdir enn.',
    'calendar.board.placeholder': 'Skrifa athugasemd…',
    'calendar.board.send': 'Senda',
    'calendar.board.reply': 'Svara',
    'calendar.board.replying_to': 'Svar til {name}',
    'calendar.board.cancel_reply': 'Hætta við svar',
    'calendar.board.edited': 'breytt',
    'calendar.board.deleted': 'Athugasemd eytt',
    'calendar.board.left': '(hættur)',
    'calendar.board.delete_title': 'Eyða athugasemd?',
    'calendar.board.delete_body': 'Athugasemdin hverfur af spjallinu.',
    'calendar.board.sending': 'Sendi…',
    'calendar.board.queued': 'Bíður eftir neti',
    'calendar.board.failed': 'Ekki sent',
    'calendar.board.discard': 'Henda',
    'calendar.board.load_error': 'Ekki tókst að sækja skilaboð.',
    'calendar.board.new': 'Ný',

    'calendar.new.title': 'Nýr viðburður',
    'calendar.new.series': 'Æfingaröð',
    'calendar.new.series_desc': 'Endurteknar æfingar, t.d. alla miðvikudaga',
    'calendar.new.single': 'Stakur viðburður',
    'calendar.new.single_desc': 'Tónleikar, aukaæfing eða annað',

    'calendar.form.title': 'Heiti',
    'calendar.form.kind': 'Tegund',
    'calendar.form.weekdays': 'Vikudagar',
    'calendar.form.interval': 'Endurtekning',
    'calendar.form.weekly': 'Vikulega',
    'calendar.form.biweekly': 'Aðra hverja viku',
    'calendar.form.every_n_weeks': 'Á {count} vikna fresti',
    'calendar.form.start_time': 'Hefst kl.',
    'calendar.form.end_time': 'Lýkur kl.',
    'calendar.form.date': 'Dagsetning',
    'calendar.form.starts_on': 'Fyrsta æfing',
    'calendar.form.until_on': 'Síðasta æfing',
    'calendar.form.until_hint': 'Valfrjálst – tómt þýðir að röðin heldur áfram.',
    'calendar.form.location': 'Staður',
    'calendar.form.location_ph': 'T.d. Grafarvogskirkja',
    'calendar.form.description': 'Lýsing',
    'calendar.form.description_ph': 'Valfrjálst – t.d. hvað á að æfa eða klæðnaður',
    'calendar.form.audience': 'Fyrir hverja?',
    'calendar.form.checkin_opens': 'Mætingarskráning opnast',
    'calendar.form.checkin_min': '{count} mín. fyrir upphaf',
    'calendar.form.checkin_hours': { one: '{count} klst. fyrir upphaf', other: '{count} klst. fyrir upphaf' },
    'calendar.form.checkin_at_start': 'Þegar viðburðurinn hefst',
    'calendar.form.setlist': 'Lagalisti',
    'calendar.form.no_setlist': 'Enginn lagalisti',
    'calendar.form.counts_attendance': 'Telst til mætingar',
    'calendar.form.counts_attendance_hint': 'Tekið með í mætingartölfræði kórsins.',
    'calendar.form.duration_hm': 'Lengd: {h} klst. {m} mín.',
    'calendar.form.duration_h': 'Lengd: {h} klst.',
    'calendar.form.duration_m': 'Lengd: {m} mín.',
    'calendar.form.next_day': 'Lýkur daginn eftir',
    'calendar.form.from_date': 'Breytingarnar gilda frá og með {date}.',
    'calendar.form.summary_weekly': 'Vikulega á {days} kl. {time}',
    'calendar.form.summary_biweekly': 'Aðra hverja viku á {days} kl. {time}',
    'calendar.form.new_series': 'Ný æfingaröð',
    'calendar.form.edit_series': 'Breyta æfingaröð',
    'calendar.form.new_event': 'Nýr viðburður',
    'calendar.form.edit_event': 'Breyta viðburði',
    'calendar.form.edit_occurrence': 'Breyta þessari æfingu',
    'calendar.form.err_title': 'Sláðu inn heiti.',
    'calendar.form.err_weekdays': 'Veldu a.m.k. einn vikudag.',
    'calendar.form.err_audience': 'Veldu a.m.k. einn hóp.',
    'calendar.form.err_until': 'Síðasta æfing getur ekki verið á undan þeirri fyrstu.',
    'calendar.form.err_time': 'Sláðu inn tíma.',
    'calendar.form.err_date': 'Veldu dagsetningu.',
    'calendar.form.series_saved': 'Æfingaröð vistuð',
    'calendar.form.event_saved': 'Viðburður vistaður',
    'calendar.form.loading_series': 'Sæki æfingaröð…',

    'calendar.scope.title': 'Hverju viltu breyta?',
    'calendar.scope.only_this': 'Aðeins þessi',
    'calendar.scope.only_this_desc': 'Breytir aðeins æfingunni þann {date}.',
    'calendar.scope.following': 'Þessi og næstu',
    'calendar.scope.following_desc': 'Breytir þessari æfingu og öllum sem á eftir koma.',

    'calendar.actions.title': 'Stjórnun viðburðar',
    'calendar.actions.roster': 'Mætingarlisti',
    'calendar.actions.edit': 'Breyta',
    'calendar.actions.cancel': 'Fella niður',
    'calendar.actions.uncancel': 'Setja aftur á dagskrá',
    'calendar.actions.delete': 'Eyða viðburði',
    'calendar.actions.delete_series': 'Eyða æfingaröð',
    'calendar.cancel.title': 'Fella viðburðinn niður?',
    'calendar.cancel.body': 'Félagar sjá að viðburðurinn fellur niður. Svör og spjall haldast.',
    'calendar.cancel.reason': 'Ástæða',
    'calendar.cancel.reason_ph': 'Valfrjálst – t.d. „stjórnandi veikur“',
    'calendar.cancel.confirm': 'Fella niður',
    'calendar.cancel.keep': 'Nei, halda',
    'calendar.cancel.done': 'Viðburðurinn fellur niður',
    'calendar.uncancel.done': 'Viðburðurinn er aftur á dagskrá',
    'calendar.delete.title': 'Eyða viðburði?',
    'calendar.delete.body': 'Viðburðurinn hverfur úr dagatalinu.',
    'calendar.delete.done': 'Viðburði eytt',
    'calendar.delete.done_cancelled': 'Viðburðurinn hafði svör eða athugasemdir og var því felldur niður í stað þess að eyða honum.',
    'calendar.delete_series.title': 'Eyða æfingaröðinni?',
    'calendar.delete_series.body':
      'Allar komandi æfingar í röðinni hverfa úr dagatalinu. Liðnar æfingar og mætingarskráning þeirra haldast óbreyttar.',
    'calendar.delete_series.done': 'Æfingaröð eytt',

    'calendar.roster.title': 'Mætingarlisti',
    'calendar.roster.present': 'Mætt/ur',
    'calendar.roster.absent': 'Fjarverandi',
    'calendar.roster.excused': 'Boðuð forföll',
    'calendar.roster.unmarked': 'Ómerkt',
    'calendar.roster.checked_in': 'Skráði sig kl. {time}',
    'calendar.roster.offline': 'án nets',
    'calendar.roster.on_leave': 'í leyfi',
    'calendar.roster.former': 'hættur',
    'calendar.roster.tap_hint': 'Ýttu á félaga til að skipta: Mætt/ur → Fjarverandi → Boðuð forföll → ómerkt.',
    'calendar.roster.empty': 'Enginn er á mætingarlistanum.',
    'calendar.roster.section_count': '{present} af {total} mætt',
    'calendar.roster.coming': 'Ætla að koma',
    'calendar.roster.mark_label': '{name}: {state}. Ýttu til að breyta.',
  },
  {
    'calendar.title': 'Calendar',
    'calendar.next_up': 'Coming up next',
    'calendar.nothing_upcoming': 'Nothing scheduled',
    'calendar.nothing_upcoming_hint': 'There are no events in the coming weeks.',
    'calendar.agenda_title': 'Next 30 days',
    'calendar.agenda_empty': 'Nothing scheduled in the next 30 days.',
    'calendar.day_empty': 'Nothing scheduled on this day.',
    'calendar.show_agenda': 'Show next 30 days',
    'calendar.today': 'Today',
    'calendar.prev_month': 'Previous month',
    'calendar.next_month': 'Next month',
    'calendar.day_events': { one: '{count} event', other: '{count} events' },
    'calendar.load_error': 'Could not load the calendar.',
    'calendar.saved_offline': 'Saved – will be sent when you are back online',
    'calendar.pending_send': 'Waiting to be sent',

    'calendar.rejected.rsvp': 'Not saved: the reply you gave while offline was not accepted.',
    'calendar.rejected.checkin': 'Not saved: the check-in you made while offline was not accepted.',
    'calendar.rejected.comment': 'Not saved: the message you wrote while offline was not sent.',
    'calendar.rejected.roster': 'Not saved: an attendance change made while offline was not accepted.',

    'calendar.err.started': 'The event has started, so the reply can no longer be changed.',
    'calendar.err.cancelled': 'The event has been cancelled.',
    'calendar.err.series_ended':
      'This rehearsal cannot be reinstated because it no longer belongs to its series (the series was changed or has ended).',
    'calendar.err.outside_window': 'Check-in is only open from shortly before the event starts until it ends.',
    'calendar.err.bad_time_range': 'The event must end after it starts and cannot last more than 14 days.',
    'calendar.err.setlist_not_found': 'The setlist was not found. Choose another one.',
    'calendar.err.program_song_not_found': 'A song on the list no longer exists (it was deleted). Remove it and save again.',
    'calendar.err.program_collection_not_found': 'A folder or setlist on the list no longer exists. Remove it and save again.',
    'calendar.err.reply_to_invalid': 'The message you replied to no longer exists.',
    'calendar.err.deleted': 'This has been deleted.',

    'calendar.kind.practice': 'Rehearsal',
    'calendar.kind.sectional': 'Sectional',
    'calendar.kind.concert': 'Concert',
    'calendar.kind.other': 'Other',

    'calendar.wd.1': 'Mon',
    'calendar.wd.2': 'Tue',
    'calendar.wd.3': 'Wed',
    'calendar.wd.4': 'Thu',
    'calendar.wd.5': 'Fri',
    'calendar.wd.6': 'Sat',
    'calendar.wd.7': 'Sun',
    'calendar.wd_on.1': 'Mondays',
    'calendar.wd_on.2': 'Tuesdays',
    'calendar.wd_on.3': 'Wednesdays',
    'calendar.wd_on.4': 'Thursdays',
    'calendar.wd_on.5': 'Fridays',
    'calendar.wd_on.6': 'Saturdays',
    'calendar.wd_on.7': 'Sundays',

    'calendar.rsvp.question': 'Are you coming?',
    'calendar.rsvp.yes': 'Coming',
    'calendar.rsvp.no': 'Not coming',
    'calendar.rsvp.maybe': 'Maybe',
    'calendar.rsvp.none': 'No reply',
    'calendar.rsvp.unanswered_hint': 'Let us know whether you are coming.',
    'calendar.rsvp.closed': 'Replies can’t be changed once the event has started.',
    'calendar.rsvp.not_invited': 'This event is not for your section.',
    'calendar.note.label': 'Note',
    'calendar.note.add': 'Add a note',
    'calendar.note.placeholder': 'E.g. “arriving 20 min late”',
    'calendar.note.need_rsvp': 'Choose Coming, Not coming or Maybe first.',
    'calendar.note.save': 'Save note',
    'calendar.note.counter': '{n} / {max}',

    'calendar.checkin.button': 'Check in',
    'calendar.checkin.done': 'Checked in at {time}',
    'calendar.checkin.opens_at': 'Check-in opens at {time}',
    'calendar.checkin.saved': 'Checked in',

    'calendar.event.title': 'Event',
    'calendar.event.cancelled': 'Cancelled',
    'calendar.event.cancelled_banner': 'This event has been cancelled',
    'calendar.event.reason': 'Reason: {reason}',
    'calendar.event.open_map': 'Open location in Maps',
    'calendar.event.audience': 'For',
    'calendar.event.details': 'Details',
    'calendar.event.not_found': 'The event was not found or you do not have access to it.',
    'calendar.event.recurring': 'Part of a rehearsal series',
    'calendar.event.your_reply': 'Your reply',
    'calendar.event.comments': { one: '{count} message', other: '{count} messages' },
    'calendar.event.unread': { one: '{count} new', other: '{count} new' },
    'calendar.event.ongoing': 'Happening now',
    'calendar.event.ended': 'Ended',
    'calendar.event.description': 'About this event',

    'calendar.headcount.title': 'Who is coming',
    'calendar.headcount.coming': { one: '{count} coming', other: '{count} coming' },
    'calendar.headcount.coming_word': { one: 'coming', other: 'coming' },
    'calendar.headcount.detail': 'No {no} · Maybe {maybe} · No reply {none}',
    'calendar.headcount.low': { one: 'Only {count} coming in {section}', other: 'Only {count} coming in {section}' },
    'calendar.headcount.nobody': 'Nobody coming in {section}',
    'calendar.headcount.total': 'Total',
    'calendar.headcount.unanswered': { one: '{count} hasn’t replied', other: '{count} haven’t replied' },

    'calendar.board.title': 'Messages',
    'calendar.board.empty': 'No messages yet.',
    'calendar.board.placeholder': 'Write a message…',
    'calendar.board.send': 'Send',
    'calendar.board.reply': 'Reply',
    'calendar.board.replying_to': 'Replying to {name}',
    'calendar.board.cancel_reply': 'Cancel reply',
    'calendar.board.edited': 'edited',
    'calendar.board.deleted': 'Message deleted',
    'calendar.board.left': '(left)',
    'calendar.board.delete_title': 'Delete message?',
    'calendar.board.delete_body': 'The message will be removed from the board.',
    'calendar.board.sending': 'Sending…',
    'calendar.board.queued': 'Waiting for connection',
    'calendar.board.failed': 'Not sent',
    'calendar.board.discard': 'Discard',
    'calendar.board.load_error': 'Could not load messages.',
    'calendar.board.new': 'New',

    'calendar.new.title': 'New event',
    'calendar.new.series': 'Rehearsal series',
    'calendar.new.series_desc': 'Repeating rehearsals, e.g. every Wednesday',
    'calendar.new.single': 'One-off event',
    'calendar.new.single_desc': 'Concert, extra rehearsal or other',

    'calendar.form.title': 'Title',
    'calendar.form.kind': 'Type',
    'calendar.form.weekdays': 'Weekdays',
    'calendar.form.interval': 'Repeats',
    'calendar.form.weekly': 'Every week',
    'calendar.form.biweekly': 'Every other week',
    'calendar.form.every_n_weeks': 'Every {count} weeks',
    'calendar.form.start_time': 'Starts at',
    'calendar.form.end_time': 'Ends at',
    'calendar.form.date': 'Date',
    'calendar.form.starts_on': 'First rehearsal',
    'calendar.form.until_on': 'Last rehearsal',
    'calendar.form.until_hint': 'Optional – leave empty for no end date.',
    'calendar.form.location': 'Location',
    'calendar.form.location_ph': 'E.g. Grafarvogskirkja',
    'calendar.form.description': 'Description',
    'calendar.form.description_ph': 'Optional – e.g. what to rehearse or dress code',
    'calendar.form.audience': 'Who is it for?',
    'calendar.form.checkin_opens': 'Check-in opens',
    'calendar.form.checkin_min': '{count} min before start',
    'calendar.form.checkin_hours': { one: '{count} hour before start', other: '{count} hours before start' },
    'calendar.form.checkin_at_start': 'When the event starts',
    'calendar.form.setlist': 'Setlist',
    'calendar.form.no_setlist': 'No setlist',
    'calendar.form.counts_attendance': 'Counts towards attendance',
    'calendar.form.counts_attendance_hint': 'Included in the choir’s attendance statistics.',
    'calendar.form.duration_hm': 'Duration: {h} h {m} min',
    'calendar.form.duration_h': 'Duration: {h} h',
    'calendar.form.duration_m': 'Duration: {m} min',
    'calendar.form.next_day': 'Ends the next day',
    'calendar.form.from_date': 'The changes apply from {date}.',
    'calendar.form.summary_weekly': 'Weekly on {days} at {time}',
    'calendar.form.summary_biweekly': 'Every other week on {days} at {time}',
    'calendar.form.new_series': 'New rehearsal series',
    'calendar.form.edit_series': 'Edit rehearsal series',
    'calendar.form.new_event': 'New event',
    'calendar.form.edit_event': 'Edit event',
    'calendar.form.edit_occurrence': 'Edit this rehearsal',
    'calendar.form.err_title': 'Enter a title.',
    'calendar.form.err_weekdays': 'Choose at least one weekday.',
    'calendar.form.err_audience': 'Choose at least one group.',
    'calendar.form.err_until': 'The last rehearsal cannot be before the first.',
    'calendar.form.err_time': 'Enter a time.',
    'calendar.form.err_date': 'Choose a date.',
    'calendar.form.series_saved': 'Series saved',
    'calendar.form.event_saved': 'Event saved',
    'calendar.form.loading_series': 'Loading series…',

    'calendar.scope.title': 'What do you want to change?',
    'calendar.scope.only_this': 'Only this one',
    'calendar.scope.only_this_desc': 'Changes only the rehearsal on {date}.',
    'calendar.scope.following': 'This and following',
    'calendar.scope.following_desc': 'Changes this rehearsal and all later ones.',

    'calendar.actions.title': 'Manage event',
    'calendar.actions.roster': 'Attendance',
    'calendar.actions.edit': 'Edit',
    'calendar.actions.cancel': 'Cancel event',
    'calendar.actions.uncancel': 'Reinstate event',
    'calendar.actions.delete': 'Delete event',
    'calendar.actions.delete_series': 'Delete series',
    'calendar.cancel.title': 'Cancel this event?',
    'calendar.cancel.body': 'Members will see that the event is cancelled. Replies and messages are kept.',
    'calendar.cancel.reason': 'Reason',
    'calendar.cancel.reason_ph': 'Optional – e.g. “conductor is ill”',
    'calendar.cancel.confirm': 'Cancel event',
    'calendar.cancel.keep': 'No, keep it',
    'calendar.cancel.done': 'Event cancelled',
    'calendar.uncancel.done': 'The event is back on',
    'calendar.delete.title': 'Delete event?',
    'calendar.delete.body': 'The event will be removed from the calendar.',
    'calendar.delete.done': 'Event deleted',
    'calendar.delete.done_cancelled': 'The event had replies or messages, so it was cancelled instead of deleted.',
    'calendar.delete_series.title': 'Delete the series?',
    'calendar.delete_series.body':
      'All upcoming rehearsals in the series will be removed from the calendar. Past rehearsals and their attendance are kept.',
    'calendar.delete_series.done': 'Series deleted',

    'calendar.roster.title': 'Attendance',
    'calendar.roster.present': 'Present',
    'calendar.roster.absent': 'Absent',
    'calendar.roster.excused': 'Excused',
    'calendar.roster.unmarked': 'Not marked',
    'calendar.roster.checked_in': 'Checked in at {time}',
    'calendar.roster.offline': 'offline',
    'calendar.roster.on_leave': 'on leave',
    'calendar.roster.former': 'former member',
    'calendar.roster.tap_hint': 'Tap a member to cycle: Present → Absent → Excused → not marked.',
    'calendar.roster.empty': 'Nobody is on the attendance list.',
    'calendar.roster.section_count': '{present} of {total} present',
    'calendar.roster.coming': 'Plan to come',
    'calendar.roster.mark_label': '{name}: {state}. Tap to change.',
  },
);
